import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { serviceMiddleware } from "./middlewares";
import { reducerBitel, reducerAirtimeBitel } from "./Future/Bitel/reducer";
import { reducerHalotel } from "./Future/Halotel/reducer";
import { reducerMagicWheel, reducerMytel, reducerMytelErrorCode, reducerMytelVm } from "./Future/Mytel/reducer";
import { reducerInfoRevenue } from "./Future/Common/reducer";
import { reducerUnitel, reducerVmUnitel } from "./Future/Unitel/reducer";
import { reducerNatcom } from "./Future/Natcom/reducer";
import { reducerBicagame } from "./Future/Bicagame/reducer";
import { reducerMovitel } from "./Future/Movitel/reducer";

const reducers = combineReducers({
  dataBitel: reducerBitel,
  dataAirtimeBitel: reducerBitel,
  dataHalotel: reducerHalotel,
  dataMytel: reducerMytel,
  dataMytelErrorCode: reducerMytelErrorCode,
  dataUnitel: reducerUnitel,
  dataInfoRevenue: reducerInfoRevenue,
  reducerNatcom: reducerNatcom,
  reducerAirtimeBitel: reducerAirtimeBitel,
  reducerVmUnitel: reducerVmUnitel,
  reducerMytelErrorCode: reducerMytelErrorCode,
  reducerMytelVm: reducerMytelVm,
  dataMagicWheel: reducerMagicWheel,
  dataBicagame: reducerBicagame,
  dataMovitel: reducerMovitel,
});

export function configureStore(initialState = {}) {
  const store = createStore(
    reducers,
    initialState,
    composeWithDevTools(applyMiddleware(thunk, serviceMiddleware))
  );
  return store;
}

export { reducers };

export const store = configureStore();
